// extracted by mini-css-extract-plugin
export default {"container":"Tr-z","heading":"Ur-z","text":"Vr-z","info":"Wr-z","link":"Xr-z","fullMaxWidth":"Yr-z"};